import * as React from "react";

import "./dropdown-field.scss";

import {bindInput} from "@Common/react/bind-input";

import {getInfoTip} from "../common/get-info-tip";

export const DropdownField = ({xdQaName, textField, cc}) => (
    <div className="relative">
        <select {...{
            ...bindInput(textField),
            "xd-qa-type":"dropdown",
            "xd-qa-name": xdQaName,
            style:{
                borderColor: textField.isRequired && !textField.value ? "red": null,
                borderWidth: textField.isRequired && !textField.value ? 2: null,
            }
        }}>
            {textField.placeholders._collection[0].values.map((option, index) =>
                <option value={option} key={index} xd-qa-type="dropdown_item" xd-qa-name={[xdQaName, option].filter(v=>v).join(" ")}>{option}</option>
            )}
        </select>
        {getInfoTip(textField, cc.sourceData)}
    </div>
);

